module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/onboarding-2ec91b05896eff0d9a050e3f240dee58.svg";